<template>
  <div class="min-h-screen">
    <MaterialsShowView :fetch-route="materialShowRoute" @update-material="updateSeo($event)" />
  </div>
</template>
<script setup lang="ts">
import getAllRoutes from '~/composables/AppApiRoutes'
const { isAuthLoggedIn } = useMenuModel()
const isAuthenticated = isAuthLoggedIn()
const materialShowRoute =
  getAllRoutes(isAuthenticated).materialsRoutes.materialShowByServer
const { url } = useDomainHost()
const { t } = useI18n()
function updateSeo(material: Material) {
  useServerSeoMeta(
    useOgMeta(
      url + '/delivering/materials/' + material?.id,
      material?.name,
      material?.summary,
      material?.thumb
    )
  )
  useHead({
    title: material?.name,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: material?.summary
      }
    ],
    link: [useSeoCanonical(url + '/delivering/materials/' + material?.id)],
    script: [
      useSeoBreadcrumb([
        useSeoBreadcrumbItem(1, t('home'), url),
        useSeoBreadcrumbItem(2, t('at_yours'), url + '/delivering'),
        useSeoBreadcrumbItem(3, t('materials'), url + '/delivering/materials'),
        useSeoBreadcrumbItem(
          4,
          material?.name,
          url + '/delivering/materials/' + material?.id
        )
      ]),
      material ? useSeoProduct(material) : {}
    ]
  })
}
</script>
